import type { SVGIcon } from "@tql/ui-components-react/kendo/common";
import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { ReactNode } from "react";

import styles from "./ar-dashboard-card.module.css";

type ArDashboardProps = {
	readonly icon: SVGIcon | undefined;
	readonly title: string;
	readonly content: ReactNode;
	readonly headerContent?: ReactNode;
	readonly variant?: "default" | "alt";
};

export const ArDashboardCard = ({
	icon,
	title,
	content,
	headerContent,
	variant = "default",
}: ArDashboardProps) => {
	const cardClass =
		variant === "alt"
			? `${styles.arDashboardCard} ${styles.arDashboardCardAlt}`
			: styles.arDashboardCard;

	return (
		<div className={cardClass}>
			<div className={styles.arDashboardCardHeader}>
				<SvgIcon icon={icon} size={"xlarge"} />
				<h4 className={styles.arDashboardCardTitle}>{title}</h4>
				{headerContent}
			</div>
			{content}
		</div>
	);
};
